import { apiSlice } from 'store/slices/api/api-slice';
import {
    AvatarImagesRequest,
    AvatarImageSuccessResponse,
    AvatarListResponse,
    AvatarSystemListRequest,
    NewAvatarRequest,
} from 'types/avatar-system/avatar-system';

export const creatAvatar = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        addAvatar: builder.mutation<void, NewAvatarRequest>({
            query: (newAvatarRequest: NewAvatarRequest) => ({
                url: '/avatar/add-avatar',
                method: 'POST',
                body: { ...newAvatarRequest },
            }),
        }),
        avatarImageUpdate: builder.mutation<
            AvatarImageSuccessResponse,
            AvatarImagesRequest
        >({
            query: (avatarImagesRequest: AvatarImagesRequest) => ({
                url: `/avatar/add-avatar-image/` + avatarImagesRequest.avatarId,
                method: 'POST',
                body: avatarImagesRequest.image,
                header: {},
            }),
        }),

        avatarList: builder.query<AvatarListResponse, AvatarSystemListRequest>({
            query: (params: AvatarSystemListRequest) => ({
                url: '/avatar/avatar-list-admin',
                method: 'GET',
                params: params,
            }),
        }),

        avatarCategory: builder.query<string[], void>({
            query: () => ({
                url: '/avatar/avatar-category-enum',
                method: 'GET',
            }),
        }),
    }),
});
export const {
    useAddAvatarMutation,
    useAvatarImageUpdateMutation,
    useLazyAvatarListQuery,
    useAvatarCategoryQuery,
} = creatAvatar;
